import { getMyTickets } from '_models/redux/my-tickets/action';
import { connect } from 'react-redux';
import CustomerProfileHeaderUser from '../userTickets/components/CustomerProfileHeaderUser';
import RowButton from './RowButton';
import ClientsTicketsDatagrid from './widgets/TicketsDatagrid';

const ClientTicketsPage = () => {
  return (
    <div>
      <CustomerProfileHeaderUser />
      <RowButton />
      <ClientsTicketsDatagrid />
    </div>
  );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = { getMyTickets };

export default connect(mapStateToProps, mapDispatchToProps)(ClientTicketsPage);
